import { render } from "./bubbleItem.vue?vue&type=template&id=a509b9f6&scoped=true&ts=true"
import script from "./bubbleItem.vue?vue&type=script&lang=ts"
export * from "./bubbleItem.vue?vue&type=script&lang=ts"

import "./bubbleItem.vue?vue&type=style&index=0&id=a509b9f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a509b9f6"]])

export default __exports__